module.exports = __webpack_public_path__ + "img/2038a5c41907016ce18d43e60176344.4fb9069d.png";